<template>
<div class="columns is-centered mt-6">
  <div class="column is-two-thirds">
    <div class="card">
      <div class="card-header">
        <p class="card-header-title">Select a Nickname</p>
      </div>
      <div class="card-content">
        <div class="content">
          <p class="subtitle is-6 pb-5">
            This nickname will be shown on the public scoreboard instead of your name and surname.
          </p>
          <b-field label="Nickname" label-position="on-border">
            <b-input ref="nickname" type="text" v-model="nickname" placeholder="nickname" expanded required focus v-on:keyup.enter="login"></b-input>
          </b-field>
          <div class="buttons is-centered mt-4">
            <b-button type="is-primary" @click="login">Set Nickname</b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      nickname: '',
    };
  },
  mounted() {
    this.$nextTick(() => this.$refs.nickname.focus());
  },
  methods: {
    async login() {
      try {
        const res = await this.$ctforge.api.post('/saml/activate', {
          nickname: this.nickname,
        });
        this.notify(res.message);
        await this.$ctforge.checkLogin();
        this.$router.push('/');
      } catch (e) {
        this.notify(e.message, 'is-danger');
      }
    },
  },
};
</script>

<style>
</style>
